/**
 * Convert a city name to a URL-safe slug and back. Lossy on the way
 * back (we lowercase, lose punctuation) but good enough for matching:
 * the dedicated /locations/[city] page resolves the slug against
 * `venue.city` with case-insensitive equality after slugifying both
 * sides, so "New York" and "new-york" both resolve correctly.
 */
export function citySlug(city: string): string {
  return city
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

/** Pretty label for a slug — title-cases each word; used in headings until we know the canonical city name. */
export function cityFromSlug(slug: string): string {
  return slug
    .split('-')
    .map(s => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ')
}
